<template>
  <!-- 团队介绍 -->
  <div class="team">
    <div style="text-align: right; ">
      <el-button size="small" @click="add" type="success">添加</el-button>
      <el-button size="small" @click="save" type="primary">保存数据</el-button>
    </div>
    <div v-for="(item,i) in tableData" :key="i" class="item">
      <el-form label-width="8rem">
        <el-form-item label="团队或个人照片">
          <el-upload class="avatar-uploader" :http-request="(e)=>{uploadfile(e,i)}" action="" :show-file-list="false">
            <img v-if="item.picture" :src="item.picture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <i  @click="del(item,i)" class=" el-icon-remove-outline" style="position: absolute;
            top: 0;
            left: 11rem;
            font-size: 1.2rem;
            color: #f00;
            font-weight: 600;
            cursor: pointer;"></i>
          <!-- <el-button class="undock" type="warning">移除</el-button> -->
        </el-form-item>
        <el-form-item label="团队或个人名称">
          <el-input maxlength="10" show-word-limit v-model="item.name"></el-input>
        </el-form-item>

        <el-form-item label="团队或个人介绍">
          <el-input maxlength="100" show-word-limit type="textarea" :rows="3" v-model="item.remark"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
import api from '@/apis/recommend/team'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
 

      tableData: [
        {
          name: '',//名称
          picture: '',//图片
          remark: '',//介绍
        },
      ],
    }
  },
  mounted() {

    this. getlist()
  },
  methods: {
    getlist(){
    api.list({
      params:{
        limit:100,
        page:1
      }
    }).then((res) => {
      if (res.code === 10000) {
        if (res.data.list.length) {
          this.tableData = res.data.list
        }
      } else {
        this.$message.error(res.message)
      }
    })
    },
    add() {
      this.tableData.unshift({
        name: '',//荣誉名称
        picture: '',//荣誉图片
        remark: '',//荣誉介绍
      })
    },
    del(item,i){
      this.$confirm(`确定删除数据？`).then(() => {

        if (item.id) {
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.tableData.splice(i,1)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.tableData.splice(i,1)
        }

      })
    },

    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this. getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val,i) {
      console.log(val,i);

      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.tableData[i].picture = res.data
          // this.$message.success(res.message)
          this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },




  },
}
</script>

<style lang="less">
.team {
  .el-form-item {
    margin-bottom: 15px;
  }
  .avatar-uploader {
    display: flex;
    margin-bottom: 2px;
  }
  .avatar,
  .avatar-uploader-icon {
    width: 7rem !important;
    height: 8rem !important;
    line-height: 8rem !important;
    text-align: center; display: block; border: #555e86 dashed 1px; font-size: 2rem;
  }

  .item {
    width: 40%; border: #555e86 dashed 1px; display: inline-block; margin-right: 2rem;
    margin-top: 20px; padding: 15px 30px;
  }
}
</style>